// extracted by mini-css-extract-plugin
export default {"hintContainer":"style_hintContainer__zO-iJ","fortuneWheelContainer":"style_fortuneWheelContainer__ESlpU","wheelContainer":"style_wheelContainer__XUS9j"};